import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import GlobalMeta from "../../reusable/GlobalMeta";
import InternalBanner from "../../reusable/fieldGroups/InternalBanner";
import PageMenu from "../../menus/PageMenu";
import PageContent from "../../layout/PageContent";
import ImageBGSection from "../../reusable/fieldGroups/ImageBGSection";
import { Box } from "@mui/system";
import ImageMasonry from "./ImageMasonry";
import RandomTestimonial from "../../reusable/RandomTestimonial";

export default function Careers(){

    const [pageData, setPageData]=useState();

    //Fetch page
    const { isPending, isError, data, error }=useQuery(
        ['careers'], //Query key
        ()=>axios({ //Query function
            method:'get',
            url:WP_API_Settings.endpoint+'wp/v2/pages?slug=careers&_embed=true&acf_format=standard'
        })
    );

    useEffect(()=>{
        if(data?.data){
            setPageData(data.data[0]);
        }
    },[data]);

    //console.log(pageData)

    return(
        <>
            <GlobalMeta/>
            <InternalBanner
                featuredImage={pageData?. _embedded?.['wp:featuredmedia']?.[0]?.source_url}
                banner={pageData?.acf.internal_banner}
            />
            <PageMenu
                items={pageData?.acf.page_menu}
                loading={!pageData}
            />
            <PageContent
                content={pageData?.content.rendered}
            />
            <ImageMasonry
                data={pageData?.acf.image_masonry}
            />
            <ImageBGSection
                content={pageData?.acf.image_background} 
                loading={!pageData}
            />
            <Box
                sx={{
                    m:'3rem 0'
                }}
            >
                <RandomTestimonial
                    testimonials={pageData?.acf.testimonials}
                    loading={!pageData}
                />
            </Box>
        </>
    )
}